import * as React from 'react';
import CarRentalIcon from '@mui/icons-material/CarRental';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LanIcon from '@mui/icons-material/Lan';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PeopleIcon from '@mui/icons-material/People';
import DryCleaningIcon from '@mui/icons-material/DryCleaning';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import HotelIcon from '@mui/icons-material/Hotel';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import IceSkatingIcon from '@mui/icons-material/IceSkating';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitIcon from '@mui/icons-material/ExitToApp';
import DrawerListItem from './DrawerListItem';
import { Divider } from '@mui/material';



export const mainListItems = (
  <React.Fragment>
    <DrawerListItem icon={<DashboardIcon />} title={"Dashboard"} path={""} />
    <DrawerListItem icon={<CarRentalIcon />} title={"Car Requirement"} path={"car-request"} />
    <DrawerListItem icon={<LocalShippingIcon />} title={"Courier Requirement"} path={"courier-request"} />
    <DrawerListItem icon={<AirplaneTicketIcon />} title={"Travel Tickets Booking"} path={"travel-tickets-request"} />
    <DrawerListItem icon={<HotelIcon />} title={"Hotel Booking"} path={"hotel-request"} />
    <DrawerListItem icon={<RequestQuoteIcon />} title={"Expense Claim"} path={"expense-request"} />
    <DrawerListItem icon={<DryCleaningIcon />} title={"Uniform Requirement"} path={"uniform-request"} />
    <DrawerListItem icon={<IceSkatingIcon />} title={"Shoes Requirement"} path={"shoes-request"} />
  </React.Fragment>
);

export const adminListItems = (
  <React.Fragment>
    <DrawerListItem icon={<SupervisedUserCircleIcon />} title={"Users"} path={"user"} />
    <DrawerListItem icon={<LanIcon />} title={"Departments"} path={"department"} />
    <DrawerListItem icon={<DirectionsCarIcon />} title={"Cars"} path={"car"} />
    <DrawerListItem icon={<PeopleIcon />} title={"Employees"} path={"employee"} />
    <DrawerListItem icon={<FormatListNumberedIcon />} title={"Material Type"} path={"courier-material-type"} />
    <Divider sx={{ my: 1 }} />
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <DrawerListItem icon={<SettingsIcon />} title={"Settings"} path={"settings"} />
    <DrawerListItem icon={<ExitIcon />} title={"Logout"} path={"logout"} />
  </React.Fragment>
);
